const purchase = {
  title: "HitPaw Online專業版",
  subTitle: "通過簡單透明的定價選擇正確的計畫",
  monthlyUppercase: "每月",
  montly: "每月",
  free: "免費",
  yearlyUppercase: "每年",
  yearly: "每年的",
  inService: "服務中",
  buyBtn: "立即購買",
  freeTips1: "支持最大檔案為20MB",
  freeTips2: "每天6次處理檔案機會",
  freeTips3: "正常處理速度",
  freeTips4: "正常下載速度",
  freeTips5: "每天一次去除背景機會",
  freeTips6: "允許使用所有免費工具",
  vipTips1: "不限檔案大小",
  vipTips2: "不限處理檔案個數",
  vipTips3: "下載速度提高10倍",
  vipTips4: "處理速度提高10倍",
  vipTips5: "無限制",
  vipTips6: "每天無限制去除圖片背景",
  vipTips7: "允許使用所有工具和高級功能",
  vipTips8: "自動續訂並隨時取消。",
  vipTips9: "無影片大小和數量限制",
  vipTips10: "無去除圖像背景次數限制",
  vipTips11: "影片處理和下載速度提高10倍",
  vipTips12: "訪問所有免費工具和高級功能",
  acceptTitle: "我們接受",
  modalTitle: "升級至Pro以訪問所有高級功能",
  total: "全部的",
  enterCode: "輸入碼",
  SignUpToPurchaseBtn: "註冊並去購買",
  purchaseBtn: "去購買",
  saveTips: "最多可節省{{num}}%",
  discount: "折扣",
  purchaseTips: "自動續訂並隨時取消。",
  tips: "提示：",
  promoCodeInvalidTips: "你的優惠碼無效",
};

export default purchase;
